<div class="
  fixed w-full h-[80px]! transition-all duration-300 ease-in-out z-50
  "
  [ngClass]="{
    'md:absolute md:w-[calc(100%-48px)] md:mt-6 md:ml-6 bg-[#051229] backdrop-blur-none md:bg-white/10 md:backdrop-blur-xl': isAtTop,
    'top-0 left-0 bg-theme-dark text-white shadow-lg': !isAtTop,
    'translate-y-0': !isAtTop && showMenu,
    '-translate-y-full': !isAtTop && !showMenu
  }"
>
  <div class="flex items-center justify-between gap-4 pr-2 pl-2 md:pr-6 md:pl-6 h-full">
    <!-- Logo -->
    <div class="flex items-center">
      <picture class="flex items-center gap-0 group">
        <img
          src="images/logo.svg"
          class="w-[80px]! h-auto md:w-auto  md:h-auto max-h-[60px] md:min-w-[80px]"
          alt="Tú-Consultorio Empresarial"
        />
        <span class="inline-block ml-2 whitespace-nowrap font-heading
          text-xs font-normal text-white/70 leading-tight
          md:text-2xl md:font-semibold md:text-white md:leading-normal
        ">Tú-Consultorio Empresarial</span>
      </picture>
    </div>

    <!-- Desktop Menu - Hidden on mobile -->
    <ul class="hidden md:flex items-center gap-4 md:gap-8 justify-between w-auto h-full">
      @for (item of appMenu; track $index) {
        @if (item.children) {
            <li class="text-common-white font-semibold relative group h-full flex items-center">
            <button class="flex items-center gap-1 hover:text-secondary text-base! leading-[100%]"
            >
              {{ item.label }}
              <svg
                class="w-4 h-4 transition-transform group-hover:rotate-180"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <!-- Submenú -->
            <ul class="sub-menu">
              @for (child of item.children; track $index) {
              <li>
                <a
                  [routerLink]="child.path"
                  class="block px-4 py-2 hover:bg-gray-100"
                >
                  {{ child.label }}
                </a>
              </li>
              }
            </ul>
           </li>
          } 
          @else {
            <li class="text-common-white font-semibold hover:text-secondary text-base! leading-[100%]">
              <a [routerLink]="item.path" [routerLinkActive]="'text-secondary'" [routerLinkActiveOptions]="{exact: true}">
                {{ item.label }}
              </a>
            </li>
          }         
      }
    </ul>

    <!-- Desktop Login Button - Hidden on mobile -->
    <div class="hidden md:flex items-center">
      @if (!user()) {
        <btn-main
          label="Ingresar"
          icon="person"
          (action)="router.navigate(['/auth/login'])"
        ></btn-main>
      } @else {
        <div class="relative group h-[80px]! flex items-center">
        <btn-main
          [label]="user()?.email"
          icon="person"
        ></btn-main>
        <ul
          class="sub-menu -left-6!"
        >
          
          <li>
            <a
              [routerLink]="'/user/profile'"
              class="block px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              Perfil
            </a>
          </li>
          <li>
            <a
              (click)="onLogout()"
              class="block px-4 py-2 hover:bg-gray-100 text-red-700! hover:text-secondary! cursor-pointer"
            >
              Cerrar Sesión
            </a>
          </li>
        </ul>
        </div>
        <!-- <div class="flex flex-col items-center gap-2">
          <button class="flex items-center gap-2 
          border border-secondary p-2 rounded-full bg-white
          hover:shadow-sm hover:shadow-secondary
          cursor-pointer
          "
            (click)="router.navigate(['/user/profile'])"
          >
            <span class="material-symbols-outlined text-secondary">person</span>
            <span class="text-secondary text-[12px] font-heading font-semibold">{{ user()?.email }}</span>
          </button>
        </div>         -->
      }
    </div>

    <!-- Mobile Hamburger Button - Visible only on mobile -->
    <button 
      (click)="toggleMobileMenu()"
      class="menu-mobile md:hidden flex justify-between gap-3 p-2 z-50 text-white font-semibold"
      aria-label="Toggle menu"
    >
      <span>Menu</span>
      <span class="cubes">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </span>
      <!-- <span class="w-6 h-0.5 bg-white rounded-full transition-all duration-300" 
            [class.rotate-45]="isMobileMenuOpen()"
            [class.translate-y-2]="isMobileMenuOpen()"></span>
      <span class="w-6 h-0.5 bg-white rounded-full transition-all duration-300"
            [class.opacity-0]="isMobileMenuOpen()"></span>
      <span class="w-6 h-0.5 bg-white rounded-full transition-all duration-300"
            [class.-rotate-45]="isMobileMenuOpen()"
            [class.-translate-y-2]="isMobileMenuOpen()"></span> -->
    </button>
  </div>
</div>

<!-- Mobile Menu Backdrop -->
@if (isMobileMenuOpen()) {
  <div 
    class="fixed inset-0 backdrop-blur-xl z-40 md:hidden transition-opacity duration-500"
    (click)="closeMobileMenu()"
  ></div>
}

<!-- Mobile Side Drawer -->
<div 
  class="fixed top-0 right-0 h-full w-[80%] bg-theme-dark shadow-2xl z-50 md:hidden transition-transform duration-300 ease-in-out overflow-y-auto"
  [class.translate-x-0]="isMobileMenuOpen()"
  [class.translate-x-full]="!isMobileMenuOpen()"
>
  <!-- Close Button -->
  <div class="flex justify-between p-4 pt-6 pb-2">
    <img src="images/logo.svg" alt="Tú-Consultorio Empresarial" class="w-auto h-12">
    <button 
      (click)="closeMobileMenu()"
      class="text-white p-2 hover:text-secondary transition-colors"
      aria-label="Close menu"
    >
      <svg class="w-8 h-8 transition-transform duration-300 hover:rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <!-- <div class="flex flex-col gap-6">
    <p class="text-common-black text-justify p-6">
      we are committed to delivering innovative solutions that drive growth and add value to our clients. With a team of
      experienced professionals and a passion for excellence.
    </p>
  </div> -->
  <!-- Mobile Menu Items -->
  <nav class="flex flex-col px-6 py-4 gap-2">
    @for (item of appMenu; track $index) {
      @if (item.children) {
        
        <div class="flex flex-col gap-2 relative">
          <button class="text-white text-md font-semibold flex items-center justify-between gap-1 hover:text-secondary ransition-colors py-2 border-b border-white/10"
            [ngClass]="{
              'text-secondary': item.open,
              'text-white': !item.open
            }"
            (click)="item.open = !item.open"
          >
            {{ item.label }}
            <svg
              class="w-4 h-4 transition-transform"
              [class.rotate-180]="item.open"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
          <ul class="overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out origin-top"
            [ngClass]="{
              'max-h-96 opacity-100': item.open,
    'max-h-0 opacity-0': !item.open
            }"
          >
            @for (child of item.children; track $index) {
            <li  class="text-white text-md font-semibold hover:text-secondary transition-colors py-2 border-b border-white/10">
              <a
                [routerLink]="child.path"
                (click)="closeMobileMenu()"
                class="block px-4 py-1"
              >
                {{ child.label }}
              </a>
            </li>
            }
          </ul>
        </div>
      } 
      @else {
        <a 
          [routerLink]="item.path"
          [routerLinkActive]="'text-secondary!'"
          [routerLinkActiveOptions]="{exact: true}"
          (click)="closeMobileMenu()"
          class="text-white text-md font-semibold hover:text-secondary transition-colors py-2 border-b border-white/10"
        >
          {{ item.label }}
        </a>
      }
    }
  </nav>

  <!-- Mobile Login Button centered-->
  <div class="px-6 py-4 flex justify-center">
    @if (!user()) {
    <btn-main
      label="Ingresar"
      icon="person"
      (action)="router.navigate(['/auth/login']); closeMobileMenu()"
    ></btn-main>
    } @else {
    <div class="flex flex-col items-center gap-3 w-full">
      <btn-main
        [label]="user()?.email"
        icon="person"
        (action)="router.navigate(['/user/profile']); closeMobileMenu()"
      ></btn-main>
      <button
        (click)="onLogout(); closeMobileMenu()"
        class="flex items-center gap-2 text-red-400 hover:text-red-300 text-sm font-semibold transition-colors py-2 cursor-pointer"
      >
        <span class="material-symbols-outlined text-lg">logout</span>
        Cerrar Sesión
      </button>
    </div>
    }
  </div>
</div>
